import React, { Component } from 'react';
import FormItem from '../../components/FormItem/index';
import PreviewUploadComponent from '../../components/Upload/previewImg';
import { Form, Input, Button, message } from 'antd';
import services from '../../services/api';

const { TextArea } = Input;
class IndexInfoAdd extends Component {
  constructor() {
    super();
    this.state = {
      detail: {}
    };
    this.actionType = 'add';
    this.type = '';
    this.id = '';
    this.api = 'indexInfo';
  }

  componentDidMount() {
    if (this.props.actionType) {
      this.actionType = this.props.actionType;
    } else {
      if (this.props.location.pathname.indexOf('edit') !== -1) {
        this.actionType = 'update';
        this.id = this.props.match.params.id;
        this.getDetail();
      }
      this.type = this.props.match.params.type;
    }
  }

  /**获取详情 */
  getDetail = () => {
    services[this.api].queryOne({ id: this.id }).then(data => {
      console.log(data);
      if (data.code === 0) {
        this.setState({
          detail: data.data
        });
        this.props.form.setFieldsValue({
          about_intro: data.data.about_intro,
          header_wechat: data.data.header_wechat,
          header_tel: data.data.header_tel,
          footer_info: data.data.footer_info,
          leichanzi_intro: data.data.leichanzi_intro,
          m_header_tel: data.data.m_header_tel,
          m_footer_tel: data.data.m_footer_tel,
          m_footer_wechat: data.data.m_footer_wechat,
          study_time: data.data.study_time,
          study_price: data.data.study_price,
          study_des: data.data.study_des,
          study_image: { fileUrl: data.data.study_image }
        });
      } else {
        message.error(data.msg);
      }
    });
  };

  /** 获取到列表url  */
  getListUrl = () => {
    const addUrlReg = /.+(?=\/add)/;
    const editUrlReg = /.+(?=\/\d+\/edit)/;
    if (this.props.location.pathname.match(addUrlReg) !== null) {
      return this.props.location.pathname.match(addUrlReg)[0];
    }
    if (this.props.location.pathname.match(editUrlReg) !== null) {
      return this.props.location.pathname.match(editUrlReg)[0];
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const params = {
        ...values,
        study_image: values.study_image.fileUrl
      };
      if (this.actionType === 'update') {
        params.id = this.id;
      }
      if (!err) {
        services[this.api][this.actionType](params).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            // this.props.history.push(this.getListUrl());
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };

  render() {
    const formItems1 = [
      {
        label: {
          label: '雷禅子描述',
          className: 'tantuer-form-item'
        },
        name: 'leichanzi_intro',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '雷禅子描述' }]
        },
        component: (
          <TextArea
            placeholder="雷禅子描述"
            className="default"
            style={{ width: '500px', height: '200px' }}
          />
        )
      },
      {
        label: {
          label: '关于我们',
          className: 'tantuer-form-item'
        },
        name: 'about_intro',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '关于我们' }]
        },
        component: (
          <TextArea
            placeholder="关于我们"
            className="default"
            style={{ width: '500px', height: '200px' }}
          />
        )
      },
      {
        label: {
          label: 'pc头部电话',
          className: 'tantuer-form-item'
        },
        name: 'header_tel',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="pc头部电话" className="large" />
      },
      {
        label: {
          label: 'pc头部微信',
          className: 'tantuer-form-item'
        },
        name: 'header_wechat',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="头部电话" className="large" />
      },
      {
        label: {
          label: 'pc底部文字',
          className: 'tantuer-form-item'
        },
        name: 'footer_info',
        options: {
          initialValue: ''
        },
        component: (
          <TextArea
            placeholder="pc底部文字"
            className="default"
            style={{ width: '500px', height: '200px' }}
          />
        )
      }
    ];
    const formItem2 = [
      {
        label: {
          label: '手机头部电话',
          className: 'tantuer-form-item'
        },
        name: 'm_header_tel',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="手机头部电话" className="large" />
      },
      {
        label: {
          label: '手机底部电话',
          className: 'tantuer-form-item'
        },
        name: 'm_footer_tel',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="手机底部电话" className="large" />
      },
      {
        label: {
          label: '手机底部微信',
          className: 'tantuer-form-item'
        },
        name: 'm_footer_wechat',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="手机底部微信" className="large" />
      }
    ];
    const formItem3 = [
      {
        label: {
          label: '学时',
          className: 'tantuer-form-item'
        },
        name: 'study_time',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="学时" className="large" />
      },
      {
        label: {
          label: '学费',
          className: 'tantuer-form-item'
        },
        name: 'study_price',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="学费" className="large" />
      },
      {
        label: {
          label: '手机培训描述',
          className: 'tantuer-form-item'
        },
        name: 'study_des',
        options: {
          initialValue: ''
        },
        component: (
          <TextArea
            placeholder="手机培训描述"
            className="default"
            style={{ width: '500px', height: '200px' }}
          />
        )
      },
      {
        label: {
          label: '手机培训图片',
          className: 'tantuer-form-item'
        },
        name: 'study_image',
        options: {
          initialValue: { fileUrl: '' }
        },
        component: <PreviewUploadComponent />
      }
    ];
    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems1.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <div className="tantuer-field-area">
            {formItem2.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <div className="tantuer-field-area">
            {formItem3.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            提交
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(IndexInfoAdd);
